import Icon from '../components/Icon.vue'

Icon.register({
  diagnoses: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M496 256c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM320 176c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zM59.8 364l-17.7-26.7c-8.8-13.3-7.6-34.6 10-45.1 7.4-4.4 17.5-10 28.7-16 31.6 27.3 79 4.2 79.2-36 47.1-17.7 103-32.2 160-32.2 45.1 0 89.3 9.2 129.2 21.8-11.7 52.9 59.6 81.2 87.7 35.1 21.4 10.4 39.2 20.3 51.1 27.4 17.6 10.5 18.8 31.9 10 45.1l-17.8 26.7c-10.2 15.1-29.3 17.8-42.9 9.8-16.2-9.6-56.2-31.8-105.3-48.6v90.7h-224v-90.8c-49.1 16.9-89.1 39-105.3 48.6-13.6 8-32.7 5.5-42.9-9.8zM368 344c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM272 248c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM112 256c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM624 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-608c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h608z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/diagnoses.js
// module id = 1260
// module chunks = 0